import { mockComponentRenderProp } from 'bloko/common/setupMockComponents';

export default mockComponentRenderProp('DropInfoInline', null, {
    withChildren: true,
});
